const SAVE_SIGNATURE_EVENT = 'SAVE_SIGNATURE_EVENT';

const on = (listener: EventListener) => {
	document.addEventListener(SAVE_SIGNATURE_EVENT, listener);
};
const off = (listener: EventListener) => {
	document.removeEventListener(SAVE_SIGNATURE_EVENT, listener);
};

export const SaveSignatureEvent = {
	registerHandler: (listener: EventListener) => {
		on(listener);
	},
	unRegisterHandler: (listener: EventListener) => {
		off(listener);
	},
	dispatch: (data?: any) => {
		const event = new CustomEvent(SAVE_SIGNATURE_EVENT, { detail: data });
		document.dispatchEvent(event);
	},
};
